import React from 'react';

import { Message } from '../Message/Message';

import type { StreamMessage } from '../../context/ChannelStateContext';
import type { DefaultBeloChatGenerics } from '../../types/types';

export type GiphyPreviewMessageProps<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = {
  message: StreamMessage<BeloChatGenerics>;
};

export const GiphyPreviewMessage = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  props: GiphyPreviewMessageProps<BeloChatGenerics>,
) => {
  const { message } = props;

  return (
    <div className='giphy-preview-message'>
      <Message message={message} />
    </div>
  );
};
